// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2pqVK","buttonChat":"styles_buttonChat__3zh3D","notificationCount":"styles_notificationCount__3-nlH","icon":"styles_icon__Uf491"};